import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BannerSize } from "web/script/utils/app-banner-campaign";

export interface AppDownloadBannerSlice {
    isVisible: boolean;
    bannerSize: BannerSize;
}

const appDownloadBanner = createSlice({
    name: "appDownloadBanner",
    initialState: {
        isVisible: Boolean(false),
        bannerSize: BannerSize.None,
    } as AppDownloadBannerSlice,
    reducers: {
        bannerHidden(state): void {
            state.isVisible = false;
            state.bannerSize = BannerSize.None;
        },
        bannerVisible(state): void {
            state.isVisible = true;
        },
        setBannerSize(state, action: PayloadAction<BannerSize>): void {
            state.bannerSize = action.payload;
        },
    },
});

export const { bannerHidden, bannerVisible, setBannerSize } = appDownloadBanner.actions;
export default appDownloadBanner.reducer;
